import { splitByThousands, convertToThousands} from '../../../helpers/NumberFormatter';

export function formatAxesLabel(value, index, values){
    return convertToThousands(value, 1);
}

export function formatTooltipLabel(tooltipItem, data){
    var valueLabel = data.datasets[tooltipItem.datasetIndex].label || '';
    return splitByThousands(tooltipItem.yLabel) + (valueLabel ?  ` ${valueLabel}`: '') 
}

export function formatTooltipLabelWorldMap(label, value){
    return label + (value ? (': ' + splitByThousands(value)) : '');
}

export function formatTooltipLabelPie(tooltipItem, data){
    var dataLabel = data.labels[tooltipItem.index],
        valueLabel = data.datasets[tooltipItem.datasetIndex].label,
        value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
    return `${dataLabel}: ${splitByThousands(value)} ${valueLabel}`;
}

export function formatTooltipLabelDoughnut(tooltipItem, data){
    var dataLabel = data.labels[tooltipItem.index],
        value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
    return `${dataLabel}: $${splitByThousands(value)}`;
}

export function formatTooltipLabelDoughnutWithPercentage(tooltipItem, data) {
  const dataLabel = data.labels[tooltipItem.index];
  const dataset = data.datasets[tooltipItem.datasetIndex];
  const value = dataset.data[tooltipItem.index];
  const total = dataset.data.reduce((sum, val) => sum + val, 0);
  const percent = total ? ((value / total) * 100).toFixed(1) : 0;

  return `${dataLabel}: $${splitByThousands(value)} (${percent}%)`;
}

export function formatTooltipLabelWithCurrency(tooltipItem, data){
    var dataLabel = data.datasets[tooltipItem.datasetIndex].label,
        value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
    return `${dataLabel}: $${splitByThousands(value)}`;
}

